/** Why saving a source failed, as a sentence and the server's reasons, one per line. */
export interface SaveFailure {
  readonly title: string;
  readonly items: readonly string[];
}

export function explainSave(status: number, body: unknown): SaveFailure {
  const message = (body as { message?: unknown } | null)?.message;
  const said = typeof message === 'string' && message !== '' ? [message] : [];
  if (status === 400) {
    const problems = (body as { problems?: unknown } | null)?.problems;
    return {
      title: 'Some of those settings are not usable.',
      items: Array.isArray(problems)
        ? problems.filter((p): p is string => typeof p === 'string')
        : said,
    };
  }
  if (status === 422) {
    return {
      title: 'The provider rejected those credentials. Check them and try again.',
      items: said,
    };
  }
  if (status === 403) return { title: 'Only an admin can change sources.', items: [] };
  if (status === 404) return { title: 'That source no longer exists.', items: [] };
  if (status === 503) {
    return {
      title: 'Credentials cannot be stored here: SECRETS_KEY is not configured.',
      items: [],
    };
  }
  return {
    title: 'The provider could not be reached. Nothing was stored.',
    items: said,
  };
}
